import { INSIDER_TERMS_AND_CONDITIONS_PHASE_1B_ENABLED_231130 } from "@faire/web-api/indigofair/settings/INSIDER_TERMS_AND_CONDITIONS_PHASE_1B_ENABLED_231130";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingInsiderTermsAndConditionsPhase1bEnabled = (): boolean =>
  getSettingValueWithoutAssignment(
    INSIDER_TERMS_AND_CONDITIONS_PHASE_1B_ENABLED_231130,
    false
  );
